// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__33bxG","head":"Table_head__IdpKH","col":"Table_col__2RxOC"};